// extracted by mini-css-extract-plugin
export default {"pl1":"Spinner_pl1__JoOg6","pl1g":"Spinner_pl1g__X1bb-","pl1rect":"Spinner_pl1rect__9RsBM","pl1a":"Spinner_pl1a__3D4Qj","pl1b":"Spinner_pl1b__4ZQPy","pl1c":"Spinner_pl1c__gLs9y"};